











import { SdsButtonText } from '@superbet-group/web.lib.ui-components';
import {
    isMobileLayout,
    useI18n,
} from '@superbet-group/web.lib.vue-utilities';
import {
    computed,
    defineComponent,
    ref,
} from '@vue/composition-api';

export default defineComponent({
    name: 'CopyCodeButton',
    props: {
        copyText: {
            type: String,
            required: true,
        },

    },
    setup(props) {
        const showCopySuccess = ref(false);
        const { translate } = useI18n();
        const copyQrCode = () => {
            navigator.clipboard.writeText(props.copyText);
            showCopySuccess.value = true;
            setTimeout(() => {
                showCopySuccess.value = false;
            }, 3000);
        };
        const isMobile = computed(() => isMobileLayout());

        const buttonText = computed(() => {
            if (showCopySuccess.value) {
                return translate('wallet.qrDepositModal.copied');
            } else if (isMobile.value) {
                return translate('wallet.qrDepositModal.copyQRCodeMobile');
            } else {
                return translate('wallet.qrDepositModal.copyQRCode');
            }
        });

        return {
            showCopySuccess,
            copyQrCode,
            isMobile,
            buttonText,
        };
    },
    components: {
        SdsButtonText,
    },
});
